import { normalize } from 'polished'
import { createGlobalStyle } from 'styled-components'

import { Reset } from './lib/mixins'

const Style = createGlobalStyle`
  ${normalize()}

  :root {
    --font-primary: ${({ theme }) => theme.font};

    --color-body: #ffffff;
    --color-global: ${({ theme }) => theme.colors.global};
    --color-primary: ${({ theme }) => theme.colors.primary};
    --color-inverted: #ffffff;
    --color-light: #EEEEEE;
    --color-muted: #88929E;
    --color-muted-inverted: rgba(255,255,255,0.5);
    --color-green: #0AB500;
    --color-light: #EFF3F8;
    --color-dark: #000329;
    --color-line: #DCE2EC;
    --color-line-inverted: rgba(255,255,255,0.15);
    --color-red: #C91900;

    --size-top-bar: 4rem;

    --grid-gap: 3rem;

    --view-padding-vertical: 4rem;
    --view-padding-horizontal: 5rem;
  }

  html {
	  font-size: 1.3vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.35;
    font-family: ${({ theme }) => theme.font};
    color: ${({ theme }) => theme.colors.global};;
    font-weight: 300;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0,22,137,0.05);
  }

  body {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: var(--color-body);
  }

  * {
    box-sizing: border-box;
  }


  ::-webkit-scrollbar {
    display: none;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 1.5rem;
    line-height: 1.25;
    font-weight: 500;

    strong {
      font-weight: 600;
    }
  }

  h1 {
    font-size:3rem;
    line-height: 1.15;
  }

  h2 {
    font-size: 1.85rem;
  }

  h3 {
    font-size: 1.4rem;
    margin-bottom: 1.5em;
  }

  h4 {
    font-size: 0.95rem;
  }

  h6 {
    font-size: 0.85rem;
    color: var(--color-muted);
  }

  a {
    ${Reset('link')}
    color: ${({ theme }) => theme.colors.primary};
  }

  p {
    margin-top: 0;
    margin-bottom: 2rem;
    line-height: 1.35;

    strong {
      font-weight: 600;
    }
  }

  img {
    max-width: 100%;
  }

dt {
  opacity: 0.5;
  display: inline-block;
  margin-right: 0.15em;
  &:after {
    content: ':';
  }
}

dd {
  display: inline-block;
  margin: 0 0 0.25em;
  font-weight: 400;
}
`

export default Style
